export enum TimeRecordStatusNumber {
	Draft = 'D',
	Open = 'Open',
	PendingOverride = 'PO',
	PendingVerification = 'PV',
	Verified = 'V',
	Approved = 'A',
	Locked = 'L',
	Returned = 'R',
}
